module.exports = "/packs/course_dummy_img-5aae9d14b20069c098e2282435ab53a3.png";